module.exports = __webpack_public_path__ + "img/lerner-logo.a2d40787.svg";